import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import {
  ReservationTable,
  toDateStringByDate,
} from '../../../core/types/reservation-types';

type Args = {
  reservationTable: ReservationTable | undefined;
};

/**
 * 予約テーブルの初期表示日付範囲をクエリへ反映して表示日数設定を維持する
 */
export const useSyncInitialDateRange = ({ reservationTable }: Args): void => {
  const history = useHistory();
  const location = useLocation();
  const hasSyncedRef = useRef(false);

  useEffect(() => {
    if (hasSyncedRef.current) {
      return;
    }
    const dateRange = reservationTable?.dateRange;
    if (!dateRange) {
      return;
    }

    const params = new URLSearchParams(location.search);
    if (params.has('startDate') || params.has('endDate')) {
      hasSyncedRef.current = true;
      return;
    }

    const { start, end } = dateRange;
    if (!start || !end) {
      hasSyncedRef.current = true;
      return;
    }

    params.set('startDate', toDateStringByDate(start));
    params.set('endDate', toDateStringByDate(end));
    history.replace(`${location.pathname}?${params.toString()}`);
    hasSyncedRef.current = true;
  }, [history, location.pathname, location.search, reservationTable]);
};
